// @flow

import React from 'react'
import { connect } from 'react-redux'
import bindAll from 'lodash/bindAll'
import initializers from '../../../dependencies/initializers'
import _axios from '../../../dependencies/_axios'
import { withRouter } from "react-router"
import Loader from '../../partials/LoaderNew'

type Props = {
	interviewCode: string
};

class InviteCheckInterviewCode extends React.Component<Props> {
	constructor(props) {
		super(props)

		bindAll(this, [
			'handleCheckInterviewCode'
		])

		this.state = {
			value_loader: 0,
		}
	}

	handleCheckInterviewCode() {
		const { interviewCode, history } = this.props

		setInterval(() => {
			if (this.state.value_loader < 50) {
				this.setState({ value_loader: this.state.value_loader + 5 })
			}
		}, 200)

		let appWeb = initializers.api_host
		if (interviewCode.substr(-3) == '+EU') {
			appWeb = initializers.api_host_eu
		}

		_axios({
			url: `${appWeb}/code/${interviewCode}?debug=false`,
			timeout: 200000,
			method: 'get',
			crossdomain: true
		})
		.then((data) => {
			this.setState({ value_loader: 50 })
			let qnaHost = initializers.qna_host
			if (interviewCode.substr(-3) == '+EU') {
				qnaHost = initializers.qna_host_eu
			}
			window.location = qnaHost + '/code/' + interviewCode
		})
		.catch((error) => {
			history.push('/notfound')
		})
	}

	componentDidMount() {
		this.handleCheckInterviewCode()
	}

	render() {
		const { value_loader } = this.state
		return <Loader value={value_loader} />
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		interviewCode: ownProps.match.params.interviewCode
	}
}

export default withRouter(connect(mapStateToProps, null)(InviteCheckInterviewCode))
